// services/alert/slices.js
import { createSlice } from '@reduxjs/toolkit';
import { sliceNames } from '../util/constants';
import { ALERT_SEVERITY } from '../../util/constants';

const initialState = {
  isVisible: false,
  severity: null,
  title: null,
  message: null
};

const alertSlice = createSlice({
  name: sliceNames.alert,
  initialState,
  reducers: {
    showAlert: (state, action) => {
      const { severity, title, message } = action.payload;
      state.isVisible = true;
      state.severity = severity;
      state.title = title;
      state.message = message;
    },
    clearAlert: () => initialState
  }
});

export const { showAlert, clearAlert } = alertSlice.actions;

// Selectors
export const selectAlert = (state) => state[sliceNames.alert];
export const selectAlertIsError = (state) =>
  selectAlert(state)?.severity === ALERT_SEVERITY.ERROR;
export const selectIsAlertVisible = (state) => selectAlert(state).isVisible;

export default alertSlice;
